import { atom } from 'jotai';

export const shouldStartDictationAtom = atom<string | null>(null);
